export const CLIENT = 'client';
export const EMPLOYEE = 'employee';